import { useState } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Lets any signed-in user change their own password (the old place for this
// was Admin → Settings, which only administrators can open).
export default function ChangePasswordModal({ onClose, forced = false }) {
  const { setUser } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const inp = "w-full border border-slate-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-[#4e73df]";
  const save = async (e) => {
    e.preventDefault();
    if (f.new_password.length < 6) return toast.error("New password must be at least 6 characters");
    if (f.new_password !== f.confirm) return toast.error("New passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password changed");
      if (forced) setUser((u) => ({ ...u, must_change_password: false }));
      onClose();
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return createPortal(
    <div className="fixed inset-0 z-[100] bg-black/40 flex items-center justify-center p-4" onClick={forced ? undefined : onClose}>
      <form onSubmit={save} onClick={(e) => e.stopPropagation()} className="bg-white rounded-xl shadow-xl w-full max-w-sm" data-testid="change-password-modal">
        <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
          <div><h3 className="font-bold">Change Password</h3>{forced && <p className="text-xs text-slate-500 mt-0.5">You are using a temporary password. Choose your own to continue.</p>}</div>
          {!forced && <button type="button" onClick={onClose} aria-label="Close"><X className="w-5 h-5 text-slate-400" /></button>}
        </div>
        <div className="p-5 space-y-3">
          <input type="password" autoComplete="current-password" placeholder="Current password" className={inp} value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} required />
          <input type="password" autoComplete="new-password" placeholder="New password" className={inp} value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} required />
          <input type="password" autoComplete="new-password" placeholder="Confirm new password" className={inp} value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} required />
        </div>
        <div className="px-5 py-3 border-t border-slate-100 flex justify-end gap-2">
          {!forced && <button type="button" onClick={onClose} className="px-3.5 py-2 text-sm text-slate-500">Cancel</button>}
          <button disabled={busy} className="bg-[#4e73df] hover:bg-[#3a5fd0] text-white text-sm font-semibold px-3.5 py-2 rounded-lg disabled:opacity-60">Save</button>
        </div>
      </form>
    </div>,
    document.body
  );
}
